import DiaryPage from "@/interface/pages/diary-page";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_active-subscription/users/diary")({
  component: RouteComponent,
});

function RouteComponent() {
  return <DiaryPage />;
}
